<div class="grid-container">
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"></div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
      <div class="usa-card padding-top-2">
        <div class="usa-card__container">
          <header class="usa-card__header">
            <h2 class="usa-card__heading">Reset Password</h2>
          </header>
          <div class="usa-card__body">
            <form [formGroup]="resetPasswordForm" (ngSubmit)="submitRequest()">

              @if (successMessage) {
                <div class="usa-alert usa-alert--success usa-alert--slim">
                  <div class="usa-alert__body">
                    <p class="usa-alert__text">
                      {{ successMessage }}
                    </p>
                  </div>
                </div>
              }
              @if (errorMessage) {
                <div  class="usa-alert usa-alert--error usa-alert--slim">
                  <div class="usa-alert__body">
                    <p class="usa-alert__text">
                      {{ errorMessage }}
                    </p>
                  </div>
                </div>
              }
              <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <label class="usa-label" for="email">Email</label>
                  <input type="text" readonly id="email" class="usa-input maxw-full" formControlName="email"
									[ngClass]="{
										'border-success': this.resetPasswordForm.get('email').valid && (this.resetPasswordForm.get('email').touched || this.resetPasswordForm.get('email').dirty),
										'border-danger': this.resetPasswordForm.get('email').invalid && (this.resetPasswordForm.get('email').touched || this.resetPasswordForm.get('email').dirty)
									}">
                  @if (this.resetPasswordForm.get('email').invalid && (this.resetPasswordForm.get('email').touched || this.resetPasswordForm.get('email').dirty)) {
                    <div>
                      @if (this.resetPasswordForm.get('email').hasError('required')) {
                        <small class="text-danger">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Email is required
                        </small>
                      }
                      @if (this.resetPasswordForm.get('email').hasError('email')) {
                        <small class="text-danger">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Email is invalid
                        </small>
                      }
                    </div>
                  }
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <label class="usa-label" for="secretQuestion">Security Question</label>
                  <input type="text" readonly id="secretQuestion" class="usa-input maxw-full" formControlName="secretQuestion"
									[ngClass]="{
										'border-success': this.resetPasswordForm.get('secretQuestion').valid && (this.resetPasswordForm.get('secretQuestion').touched || this.resetPasswordForm.get('secretQuestion').dirty),
										'border-danger': this.resetPasswordForm.get('secretQuestion').invalid && (this.resetPasswordForm.get('secretQuestion').touched || this.resetPasswordForm.get('secretQuestion').dirty)
									}">
                  @if (this.resetPasswordForm.get('secretQuestion').invalid && (this.resetPasswordForm.get('secretQuestion').touched || this.resetPasswordForm.get('secretQuestion').dirty)) {
                    <div>
                      @if (this.resetPasswordForm.get('secretQuestion').hasError('required')) {
                        <small class="text-danger">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Security Question is required
                        </small>
                      }
                    </div>
                  }
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <label class="usa-label" for="secretAnswer">Your Answer</label>
                  <input type="text" id="secretAnswer" class="maxw-full usa-input" formControlName="secretAnswer"
									[ngClass]="{
										'border-success': this.resetPasswordForm.get('secretAnswer').valid && (this.resetPasswordForm.get('secretAnswer').touched || this.resetPasswordForm.get('secretAnswer').dirty),
										'border-danger': this.resetPasswordForm.get('secretAnswer').invalid && (this.resetPasswordForm.get('secretAnswer').touched || this.resetPasswordForm.get('secretAnswer').dirty)
									}">
                  @if (this.resetPasswordForm.get('secretAnswer').invalid && (this.resetPasswordForm.get('secretAnswer').touched || this.resetPasswordForm.get('secretAnswer').dirty)) {
                    <div>
                      @if (this.resetPasswordForm.get('secretAnswer').hasError('required')) {
                        <small class="text-danger">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Your Answer is required
                        </small>
                      }
                    </div>
                  }
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <label for="otpCode" class="usa-label">One Time Password</label>
                  <input type="text" id="otpCode" class="maxw-full usa-input" formControlName="otpCode"
									[ngClass]="{
										'border-success': this.resetPasswordForm.get('otpCode').valid && (this.resetPasswordForm.get('otpCode').touched || this.resetPasswordForm.get('otpCode').dirty),
										'border-danger': this.resetPasswordForm.get('otpCode').invalid && (this.resetPasswordForm.get('otpCode').touched || this.resetPasswordForm.get('otpCode').dirty)
									}">
                  @if (this.resetPasswordForm.get('otpCode').invalid && (this.resetPasswordForm.get('otpCode').touched || this.resetPasswordForm.get('otpCode').dirty)) {
                    <div>
                      @if (this.resetPasswordForm.get('otpCode').hasError('required')) {
                        <small class="text-danger">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> One Time Password is required
                        </small>
                      }
                    </div>
                  }
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <label class="usa-label" for="newPassword">New Password</label>
                  <input type="password" id="newPassword" class="usa-input maxw-full" formControlName="password"
									[ngClass]="{
										'border-success': this.resetPasswordForm.get('password').valid && (this.resetPasswordForm.get('password').touched || this.resetPasswordForm.get('password').dirty),
										'border-danger': this.resetPasswordForm.get('password').invalid && (this.resetPasswordForm.get('password').touched || this.resetPasswordForm.get('password').dirty)
									}">
                  @if (this.resetPasswordForm.get('password').invalid && (this.resetPasswordForm.get('password').touched || this.resetPasswordForm.get('password').dirty)) {
                    <div>
                      @if (this.resetPasswordForm.get('password').hasError('required')) {
                        <small class="text-danger">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Password is required
                        </small>
                      }
                    </div>
                  }
                  <span class="help-text text-muted">Password must be at least 12 characters,
                    a lowercase letter, an uppercase letter, a number, a symbol,
                    no parts of your username, does not include your first name,
                    does not include your last name. Your password cannot be any of your last 24 passwords.
                  </span>
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <label class="usa-label" for="confirmPassword">Confirm Password</label>
                  <input type="password" id="confirmPassword" class="usa-input maxw-full" formControlName="confirmPassword"
									[ngClass]="{
										'border-success': this.resetPasswordForm.get('confirmPassword').valid && (this.resetPasswordForm.get('confirmPassword').touched || this.resetPasswordForm.get('confirmPassword').dirty),
										'border-danger': this.resetPasswordForm.get('confirmPassword').invalid && (this.resetPasswordForm.get('confirmPassword').touched || this.resetPasswordForm.get('confirmPassword').dirty)
									}">
                  @if (this.resetPasswordForm.get('confirmPassword').invalid && (this.resetPasswordForm.get('confirmPassword').touched || this.resetPasswordForm.get('confirmPassword').dirty)) {
                    <div>
                      @if (this.resetPasswordForm.get('confirmPassword').hasError('required')) {
                        <small class="text-danger">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Password is required
                        </small>
                      }
                      @if (this.resetPasswordForm.get('confirmPassword').hasError('same')) {
                        <small class="text-danger">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Password mismatch
                        </small>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="grid-row grid-gap-1 padding-top-105">
                <button type="button" class="usa-button"  type="submit" [disabled]="!resetPasswordForm.valid">Reset Password</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"></div>
  </div>
</div>